<template>
  <!-- <pre v-if="responseData"> testData={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img src="@/assets/header/JALAN.png" alt="JALAN" class="pbt-image" />

      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>
      <h2>Jalan</h2>
      <div class="vektor">
        <!-- First Image -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="First Image"
            class="responsive-image"
          />
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Panjang Jalan di PBT</h3>
              <p class="number">{{ numberWithCommas(panjangJalan) }} KM</p>
            </div>
          </div>
        </div>

        <!-- Second Image -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="Second Image"
            class="responsive-image"
          />
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Bilangan Blackspot di Jalan PBT</h3>
              <p class="number">
                {{ blackspot.jumlah_blackspot ?? 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-wrapper">
        <h2>Panjang Jalan Daftar Marris Mengikut Kategori</h2>
        <BarHorizontal
          :chart-data="MarrisMengikutKategoriChartData"
          :chart-categories="MarrisMengikutKategoriChartNames"
          :chart-colors="['#42a5f5']"
        />
      </div>

      <div class="chart-wrapper">
        <h2>Panjang Jalan Mengikut Permukaan Jalan</h2>
        <Bar
          :chart-data="MengikutPermukaanJalanChartData"
          :chart-categories="MengikutPermukaanJalanChartNames"
          :chart-colors="['#42a5f5']"
        />
      </div>

      <div class="chart-wrapper">
        <h2>KATEGORI JALAN</h2>
        <DonutChart :chart-data="MarrisMengikutKategoriPieChartData" />
      </div>

      <div class="chart-wrapper">
        <h2>KATEGORI BLACKSPOT</h2>
        <DonutChart :chart-data="blackspotPieChartData" />
      </div>
    </div>
    <!--
      <div class="content-wrapper">
      <h2>TABURAN JALAN</h2>  
      <MapNew />
      </div> 
    -->
  </AdminBackground>
  <PrimaryModule />
  <KejuruteraanAwamMenu />
</template>

<script setup>
import { useHttpService } from "@/httpService";
import { onMounted, ref, toRaw } from "vue";

const years = ref([]);
const states = ref(["Semua Negeri"]);
const pbt = ref([]);
const councils = ref([]);
const selectedYear = ref(2025);
const selectedsState = ref("Semua Negeri");
const selectedPbt = ref("Semua PBT");
const MarrisMengikutKategoriChartData = ref([]);
const MarrisMengikutKategoriChartNames = ref([]);

const MengikutPermukaanJalanChartData = ref([]);
const MengikutPermukaanJalanChartNames = ref([]);

const MarrisMengikutKategoriPieChartData = ref([]);
const blackspotPieChartData = ref([]);

definePage({
  alias: "/pages/pages/inspektorat/ahli-pbt",
  meta: {
    layout: "blank",
    public: true,
  },
});

const blackspot = ref({
  // eslint-disable-next-line camelcase
  jumlah_blackspot: 0,
});

const { httpGet, numberWithCommas } = useHttpService();

const responseData = ref(null);
const panjangJalan = ref(null);

async function loadDataFromApi(
  year = selectedYear.value,
  state = selectedsState.value,
  pbtValue = selectedPbt.value
) {
  try {
    const plainStates = toRaw(state);

    let queryParams = `year=${year}`;

    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach((state) => {
          const stateName =
            typeof state === "string" ? state : state.name || state.value;
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`;
          }
        });
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`;
      }
    }

    if (Array.isArray(pbtValue) && !pbtValue.includes("Semua PBT")) {
      pbtValue.forEach((pbt) => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`;
      });
    }

    const url = `kejuruteraan-awam/jalan?${queryParams}`;

    const response = await httpGet(url);

    years.value = response.years;

    states.value = ["Semua Negeri"];
    response.states.forEach((state) => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state);
      }
    });

    councils.value = response.councils;
    responseData.value = response;
    panjangJalan.value = response.data.panjang_jalan.toFixed(2);
    blackspot.value = response.data.blackspot;

    const kategoriJalan =
      responseData.value.data.jalan_daftar_marris_mengikut_kategori;

    MarrisMengikutKategoriChartNames.value = Object.keys(kategoriJalan);
    MarrisMengikutKategoriChartData.value = Object.values(kategoriJalan);

    const jalanMengikutPermukaan =
      responseData.value.data.panjang_jalan_mengikut_permukaan_jalan;

    if (
      jalanMengikutPermukaan &&
      Object.keys(jalanMengikutPermukaan).length > 0
    ) {
      MengikutPermukaanJalanChartNames.value = Object.keys(
        jalanMengikutPermukaan
      );
      MengikutPermukaanJalanChartData.value = Object.values(
        jalanMengikutPermukaan
      );
    } else {
      // Provide default labels with 0 values if no data
      MengikutPermukaanJalanChartNames.value = [
        "Asphalt",
        "Konkrit",
        "Tanah",
        "Kerikil",
      ];
      MengikutPermukaanJalanChartData.value = [0, 0, 0, 0];
    }

    MarrisMengikutKategoriPieChartData.value = Object.entries(
      kategoriJalan
    ).map(([name, value]) => ({
      name,
      value,
    }));

    blackspotPieChartData.value = Object.entries(
      responseData.value.data.blackspot
    ).map(([name, value]) => ({
      name: name.replace(/_/g, " "),
      value,
    }));
  } catch (err) {
    console.error("loadDataFromApi failed:", err);
  }
}

function handleStateChange() {
  pbt.value = [];

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : [];
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : [];
  }

  // Remove "Semua Negeri" if other states are selected
  if (
    selectedsState.value.includes("Semua Negeri") &&
    selectedsState.value.length > 1
  ) {
    selectedsState.value = selectedsState.value.filter(
      (state) => state !== "Semua Negeri"
    );
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter((pbt) => pbt !== "Semua PBT");
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"];
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"];
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach((state) => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach((councilKey) => {
          const council = councils.value[state][councilKey];
          if (council && council.value) {
            pbt.value.push(council.value);
          }
        });
      }
    });
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach((state) => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach((councilKey) => {
          const council = councils.value[state][councilKey];
          if (council && council.value) {
            pbt.value.push(council.value);
          }
        });
      }
    });
  }

  console.log("Filtered PBT:", pbt.value);
}

onMounted(() => {
  loadDataFromApi();
});

watch(
  councils,
  (newValue) => {
    if (newValue) handleStateChange();
  },
  { immediate: true }
);

watch(
  [selectedYear, selectedsState, selectedPbt],
  () => {
    loadDataFromApi(
      selectedYear.value,
      selectedsState.value,
      selectedPbt.value
    );
  },
  { immediate: true }
);
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%;
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%;
  margin-block-start: 10px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 10px;
  text-align: start;
  text-transform: uppercase;
}

.input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-block-end: 20px;
}

.input-item {
  flex: 1;
  margin-inline-end: 15px;
}

.input-item:last-child {
  margin-inline-end: 0;
}

.vektor {
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
}

.vektor-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  inline-size: 48%;
  margin-block-end: 20px;
}

.activity-box {
  position: relative;
  display: inline-block;
  overflow: hidden;
  border-radius: 10px;
  block-size: auto;
  inline-size: 100%;
}

.responsive-image {
  display: block;
  block-size: auto;
  inline-size: 100%;
}

.box-overlay {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  inset: 0;
}

.box-title {
  color: #150069;
  font-size: 1.2rem;
  font-weight: bold;
}

.box-value {
  color: #a80000;
  font-size: 1.5rem;
  font-weight: bold;
}

.activity-grid {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(4, 1fr);
}

.text-overlay {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: Arial, sans-serif;
  inset: 0;
  text-align: center;
}

.values-layered h3 {
  margin: 0;
  color: #150069;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}

.number {
  color: #a80000;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  block-size: auto;
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}

@media (max-width: 768px) {
  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  .vektor {
    flex-direction: column;
    gap: 20px;
  }

  h2 {
    font-size: 1.3rem;
  }

  .values-layered h3 {
    font-size: 16px;
  }

  .number {
    font-size: 20px;
  }

  .chart-wrapper {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .pbt-image {
    max-inline-size: 70%;
  }

  .line-under-image {
    inline-size: 70%;
  }

  h2 {
    font-size: 1.1rem;
  }

  .vektor-container {
    inline-size: 100%;
  }

  .values-layered h3 {
    font-size: 14px;
  }

  .number {
    font-size: 18px;
  }

  .input-item {
    inline-size: 100%;
    margin-inline-end: 0;
  }

  .chart-wrapper {
    padding: 10px;
    margin-block-end: 30px;
  }
}
</style>
